// extracted by mini-css-extract-plugin
export var section = "news-module--section--3HBlc";
export var heading = "news-module--heading--3fV3i";
export var news = "news-module--news--188UF";
export var article = "news-module--article--1kHJH";
export var image = "news-module--image--1699f";
export var title = "news-module--title--3nLCy";
export var description = "news-module--description--11IMi";